export default "__VITE_ASSET__Cusi6UQ9__"